export default function NoPostsMessage()
{
    return(<div className='none-found'> &#128079; Awesome! No posts found </div>)
}